// test1327
(1327 && 0);
